// Phase 7 — Sentry init MUST run before any other imports so the SDK can
// instrument React internals. No-op if REACT_APP_SENTRY_DSN is unset.
import "@/sentry";

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { SentryBoundary } from "@/components/SentryBoundary";

// Register the service worker for PWA install + Web Push (iOS 16.4+ PWA only).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((reg) => {
        // Phase 5.2.2a-rebrand: force a check for an updated worker every page
        // load. Without this, iOS waits up to 24h before fetching /sw.js again,
        // so users keep getting old-brand notifications after a rename.
        try { reg.update(); } catch (_) {}
        // If a new worker has installed AND is already waiting (because old
        // tabs still hold the previous controller), reload once it activates
        // so the new worker takes over the open page immediately.
        if (reg.waiting) {
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              installing.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch((err) => {
        // Non-fatal — the app works without it, just no PWA/push
        console.warn('Service worker registration failed:', err);
      });

    // Reload exactly once when the active worker changes (new SW took over).
    // Guarded so we don't loop on dev hot-reload.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SentryBoundary section="root">
      <App />
    </SentryBoundary>
  </React.StrictMode>,
);
